import axios from 'axios'

const authToken = process.env.REACT_APP_API_READ_TOKEN

const axiosReadInstance = axios.create()

axiosReadInstance.interceptors.request.use(
    (config: any) => {
        if (authToken) {
            config.headers['Authorization'] = `Bearer ${authToken}`
        }
        return config
    },
    (error) => {
        return Promise.reject(error)
    }
)

export default axiosReadInstance
